import { createFeatureServices } from './create';
export function defineFeatureServices(bundle, args, logger) {
    return createFeatureServices(bundle, args, logger);
}
//# sourceMappingURL=define.js.map